module.exports = __webpack_public_path__ + "static/media/placeholder.472e458d.svg";